export const contributionPrivacy = [
	"로그인 없이 공개한 한 줄·태그·관람 연월과 시야 사진을 서비스와 검색에 표시해요. 기기 열쇠 원문은 기기에만 두고 서버에는 SHA-256 해시만 보관해 글 수정·삭제 권한을 확인해요.",
	"남용 방지를 위해 기존 비밀키와 날짜로 접속 IP를 HMAC 처리하며 원문 IP를 데이터베이스에 저장하지 않아요. 남용 방지 기록은 48시간 뒤 정기 정리해요. Cloudflare Turnstile 확인 과정은 Cloudflare의 국외 인프라에서 처리해요.",
	"사진은 Cloudflare R2에 저장하며 기기와 서버에서 위치정보 등 메타데이터를 제거해요. 알아볼 수 있는 얼굴·다른 관객·공연 중 사진은 받지 않아요. 검수 전 사진은 공개하지 않아요. 한 줄·사진 삭제는 내가 공개한 글에서 할 수 있어요.",
	"투표에는 이름을 받지 않고 기기 열쇠 해시·선택·선택한 한마디만 저장해요. 투표가 만료된 뒤 14일이 지나면 정기 삭제해요. 링크를 아는 사람이 결과를 볼 수 있어요. 주최자는 한마디를 숨길 수 있어요.",
	"관심 좌석과 소식 읽음 시각은 기기에 저장해요. 소식 조회에 전송한 좌석 키와 공연명은 서버의 사람별 구독으로 보관하지 않아요. 이용 측정에는 이름·연락처·좌석·공연명·원문·금액·기기 열쇠를 보내지 않아요.",
];
export const contributionTerms = [
	"로그인 없이 남긴 한 줄은 구매·관람 인증과 구분해 표시해요. 직접 경험한 내용만 쓰고 이름·연락처·개인정보·링크·허위·차별·도용 콘텐츠는 올리지 마세요. 작성자는 서비스 표시와 검색 노출에 필요한 비독점 이용을 허락해요.",
	"공개한 한 줄과 사진의 수정·삭제에는 작성 기기의 열쇠가 필요해요. 설정의 백업은 열쇠를 포함하니 다른 사람에게 주지 마세요. 열쇠를 잃으면 해당 글 신고의 내 글 삭제 요청으로 확인을 요청할 수 있어요.",
	"사진은 직접 찍고 촬영이 허용된 빈 무대만 올려요. 저작권자·권리자는 신고 또는 문의로 게시중단을 요청할 수 있어요. 권리 침해 요청은 확인을 위해 공개를 제한하고 처리 상태를 남겨요. 접근성·안전 경험은 시설 요청만으로 조용히 삭제하지 않아요.",
	"무대 구성 제보는 공식 확인 전 참고예요. 제보만으로 공식 배치 버전을 바꾸지 않아요. 일행 투표 한마디에도 금지 게시물과 삭제 기준을 적용해요.",
];
